export enum AddressType {
    General = 0,
    Visitor = 1,
    Billing = 2,
}
